// Web mock for react-native-permissions
export const PERMISSIONS = {
  ANDROID: {
    CAMERA: 'android.permission.CAMERA',
    READ_EXTERNAL_STORAGE: 'android.permission.READ_EXTERNAL_STORAGE',
    WRITE_EXTERNAL_STORAGE: 'android.permission.WRITE_EXTERNAL_STORAGE',
    ACCESS_FINE_LOCATION: 'android.permission.ACCESS_FINE_LOCATION',
    ACCESS_COARSE_LOCATION: 'android.permission.ACCESS_COARSE_LOCATION',
    READ_MEDIA_IMAGES: 'android.permission.READ_MEDIA_IMAGES',
    READ_MEDIA_VIDEO: 'android.permission.READ_MEDIA_VIDEO',
    POST_NOTIFICATIONS: 'android.permission.POST_NOTIFICATIONS',
  },
  IOS: {
    CAMERA: 'ios.permission.CAMERA',
    PHOTO_LIBRARY: 'ios.permission.PHOTO_LIBRARY',
    LOCATION_WHEN_IN_USE: 'ios.permission.LOCATION_WHEN_IN_USE',
    NOTIFICATIONS: 'ios.permission.NOTIFICATIONS',
  },
};

export const RESULTS = {
  UNAVAILABLE: 'unavailable',
  DENIED: 'denied',
  LIMITED: 'limited',
  GRANTED: 'granted',
  BLOCKED: 'blocked',
} as const;

export async function check(_permission: string): Promise<string> {
  return RESULTS.GRANTED;
}

export async function request(_permission: string): Promise<string> {
  return RESULTS.GRANTED;
}

export async function checkMultiple(permissions: string[]): Promise<Record<string, string>> {
  const result: Record<string, string> = {};
  permissions.forEach(p => { result[p] = RESULTS.GRANTED; });
  return result;
}

export async function requestMultiple(permissions: string[]): Promise<Record<string, string>> {
  const result: Record<string, string> = {};
  permissions.forEach(p => { result[p] = RESULTS.GRANTED; });
  return result;
}

export async function openSettings(): Promise<void> {
  // No equivalent on web
}

export default {
  PERMISSIONS,
  RESULTS,
  check,
  request,
  checkMultiple,
  requestMultiple,
  openSettings,
};
